"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));

var _reactWrapDisplayName = _interopRequireDefault(require("react-wrap-display-name"));

var _context = _interopRequireDefault(require("../context"));

var withFormContext = function withFormContext(WrappedComponent) {
  var _Component = function _Component(props) {
    return React.createElement(_context.default.Consumer, null, function (formContext) {
      return React.createElement(WrappedComponent, Object.assign({}, props, {
        formContext: formContext
      }));
    });
  };

  _Component.WrappedComponent = WrappedComponent;
  _Component.displayName = (0, _reactWrapDisplayName.default)(WrappedComponent, 'withFormContext');
  (0, _hoistNonReactStatics.default)(_Component, WrappedComponent);
  return _Component;
};

var _default = withFormContext;
exports.default = _default;